import styled from 'styled-components'

export const NotFoundBgContainer = styled.div`
  height: 100vh;
`
